import { useTranslation } from 'react-i18next';

import { Tooltip } from '@work4all/components/lib/components/tooltip/Tooltip';
import {
  CheckboxRadioItem,
  CheckboxRadioItemProps,
} from '@work4all/components/lib/input/checkbox-radio-item';

type CheckboxRadioComponentProps = CheckboxRadioItemProps & {
  disabled?: boolean;
  name?: string;
};

const CheckboxRadioComponent = (props: CheckboxRadioComponentProps) => {
  const { control, checked, disabled, ...rest } = props;

  const { t } = useTranslation();

  return (
    <Tooltip
      title={disabled ? t('MASK.BILLING.ADMIN_RIGHTS_TOOLTIP') : ''}
      placement="bottom-start"
    >
      <CheckboxRadioItem
        control={control}
        checked={checked}
        defaultChecked={checked}
        disabled={disabled}
        {...rest}
      />
    </Tooltip>
  );
};

export const CheckboxItem = (props: CheckboxRadioComponentProps) => {
  return <CheckboxRadioComponent {...props} control="checkbox" />;
};

export const RadioItem = (props: CheckboxRadioComponentProps) => {
  return <CheckboxRadioComponent {...props} control="radio" />;
};
